import { render, staticRenderFns } from "./squidgame.vue?vue&type=template&id=01c47ee9"
import script from "./squidgame.vue?vue&type=script&lang=js"
export * from "./squidgame.vue?vue&type=script&lang=js"
import style0 from "./squidgame.vue?vue&type=style&index=0&id=01c47ee9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports